import { useEffect, useState } from "react";

import { LOGIN_URL, SIGNUP_URL } from "@/constants/links";

export default function Nav({ onOpenDemo }) {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const handleOpenDemo = () => {
        setOpen(false);
        onOpenDemo();
    };

    return (
        <nav
            className={`core-nav ${scrolled ? "is-scrolled" : ""}`}
            data-testid="nav"
        >
            <div className="core-container core-nav-inner">
                <a className="core-logo" href="/#top" aria-label="C-ORE C-Suites home">
                    <img
                        className="core-logo-img"
                        src="/img/core-logo.png"
                        alt="C-ORE"
                        width="100"
                        height="22"
                    />
                    <span className="accent">C-Suites</span>
                </a>
                <div className="core-nav-links" aria-label="Primary">
                    <a href="/#features">Features</a>
                    <a href="/#pricing">Pricing</a>
                    <a href="/#faq">FAQ</a>
                </div>
                <div className="core-nav-actions">
                    <a
                        className="core-btn core-btn--outline core-btn--sm"
                        href={LOGIN_URL}
                        data-testid="nav-login"
                    >
                        Login
                    </a>
                    <button
                        type="button"
                        className="core-btn core-btn--outline core-btn--sm"
                        onClick={handleOpenDemo}
                        data-testid="nav-see-demo"
                    >
                        See demo
                    </button>
                    <a
                        className="core-btn core-btn--navy core-btn--sm"
                        href={SIGNUP_URL}
                        data-testid="nav-start-trial"
                    >
                        Start free trial
                    </a>
                </div>
                <button
                    type="button"
                    className="core-nav-burger"
                    aria-label="Toggle menu"
                    aria-expanded={open}
                    onClick={() => setOpen((v) => !v)}
                    data-testid="nav-burger"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        {open ? (
                            <>
                                <line x1="5" y1="5" x2="19" y2="19" />
                                <line x1="19" y1="5" x2="5" y2="19" />
                            </>
                        ) : (
                            <>
                                <line x1="4" y1="7" x2="20" y2="7" />
                                <line x1="4" y1="12" x2="20" y2="12" />
                                <line x1="4" y1="17" x2="20" y2="17" />
                            </>
                        )}
                    </svg>
                </button>
            </div>
            <div
                className={`core-mobile-menu ${open ? "is-open" : ""}`}
                data-testid="nav-mobile-menu"
            >
                <a href="/#features" onClick={() => setOpen(false)}>
                    Features
                </a>
                <a href="#pricing" onClick={() => setOpen(false)}>
                    Pricing
                </a>
                <a href="/#faq" onClick={() => setOpen(false)}>
                    FAQ
                </a>
                <div className="mobile-actions">
                    <a
                        className="core-btn core-btn--outline core-btn--block"
                        href={LOGIN_URL}
                    >
                        Login
                    </a>
                    <button
                        type="button"
                        className="core-btn core-btn--outline core-btn--block"
                        onClick={handleOpenDemo}
                    >
                        See demo
                    </button>
                    <a
                        className="core-btn core-btn--navy core-btn--block"
                        href={SIGNUP_URL}
                    >
                        Start free trial
                    </a>
                </div>
            </div>
        </nav>
    );
}
